import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AssessRequestRaService } from 'src/app/assess-request-ra/assess-request-ra.service';
import { ExportExcelButtonComponent } from 'src/app/common/components/export-excel-button/export-excel-button.component';
import { requestFlags } from 'src/app/common/models/PureRuleDetailsModel';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import { DataService } from 'src/app/common/services/data.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { WorklistService } from '../../worklist.service';
import {
  WORKLIST_EXCEL_ADDITIONAL_COLUMNS,
  WORKLIST_EXCEL_ADDITIONAL_COLUMNS_REPORT,
  WORKLIST_SEARCH_TERM_FIELD_MAP
} from 'src/app/common/models/tableColumns';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-master-worklist',
  templateUrl: './master-worklist.component.html',
  styleUrls: ['./master-worklist.component.scss']
})
export class MasterWorklistComponent implements OnInit {
  @ViewChild('rowHoverDiv') rowHoverDiv: ElementRef;
  masterWorkListData: any;
  selectedRowData: any;
  loading = false;
  filteredRows: any = [];
  exportAllRows: any = [];
  exportFilteredRows: any = [];
  exportDialog = false;
  emptyworklistmessage = '';
  loadingWorklistMessage;
  longTextLoading = false;
  masterWorklistTableColumns = [];
  masterWorklistTableColumnsClear = [];
  flotingDivFlag = false;
  rowData;
  plmvalidityarea = {
    validityAreaCode: '',
    validityDescription: '',
    validity: '',
  };
  delegateDialog = false;
  deleteDialog = false;
  columnsDialog = false;
  selfAssignPopUp = false;
  deligatOrForwardEmailId: string;
  deligateComment: string;
  forwardToRaComment: string;
  forwardToRaPopUp = false;
  listOfEmails = [];
  usersList;
  userEmailIdSuggessionList: string[];
  userEmailList = [];
  filteredUserListVals = [];
  userValue;
  delegateOrForwardBtnFlag = true;
  delegateORForward: string;
  worklistSelectedData;
  position: string;
  worklistSelectedRowData;
  selectedRows: any = [];
  projectdetailData: any = [];
  formAssess = {
    market: [],
    division: '', formulationCategory: [], formulationType: [], formulationClass: [], formulationSubClass: [],
    fc: [], version: [], alternate: [], recipeType: [],
    description: [], name: [], quantity: [], uom: [], intendedUse: 'Any',
    prepMethod: [], comments: '', dosage: '', dosageUom: '', servingSize: '',
    selectedMarkets: [], tfcList: [], firstRequest: '', cucChanged: '', keyDate: '', requestDisplayID: '',
    requestStatus: '', isMultiComponent: '', multiComponent: [], dosageForMarkets: [], raUserId: '', createdByUserId: '',
    ifraComplianceModelList: [], regionalComplianceLevel2ModelList: [], regionalComplianceLevel3ModelList: [], projectdetailData: [],
    plmvalidityarea: this.plmvalidityarea, plmkeydate: '', isPlm: true, nonPlmrecipeId: '', nonPlmrecipeId_Version: '', nonplmRecipeSource: '', businessGroupName: ''
  };
  rejectionComments = '';
  masterWorklistColumnsOptions: any[];
  userForm: FormGroup;
  columnsAdded: any[] = [];
  columnToBeAddedDetails: any[] = [];
  columnListToAdd: any;
  allWorklistColumns: any;
  orgWorklistColumns: any;
  worklistColumnsCustomisedToShow: any[] = [];
  settings: any;
  selectedColumns: any[];
  userDetails;
  isRnD = false;
  isRA = false;
  isSuperAdmin = false;
  isRAandRnD = false;
  isRAviewer = false;
  masterWLActionCount = 0;
  addColumnButton: boolean;
  CommentsHyperLinks = [];
  ReportCommentsHyperLinks = [];
  masterWorklistTableExcelColumns = [];
  isClickHere: boolean;
  isClickHereComments: boolean;
  tableComment: any;
  commentRD = '';
  isColumnsHasHyperLinks = 'No';
  HyperLinksStartColumnNumber = 0;
  frozenColsInWorklist = [];
  openAddnlInputPopup = false;
  selectedRow: any;
  roleName = '';
  pageNumber = 1;
  pageRecordsLimit = 50;
  sortField = '';
  sortOrder = 1;
  totalSearchResults = 0;
  totalPages = 0;
  searchInput: { [key: string]: string } = {};
  searchTerm: { [key: string]: string } = {};
  constructor(
    private router: Router,
    public worklistservice: WorklistService,
    public matSnackBar: MatSnackBar,
    private dataTrans: DataService,
    public assessraService: AssessRequestRaService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {
    this.userForm = this.fb.group({
      name: [],
      column: this.fb.array([
        this.fb.control(null)
      ])
    });
  }

  ngOnInit() {
    const roleData = localStorage.getItem('roles');
    const data = roleData.split(',');
    let listRole = [];
    for (const val of data) {
      if (val.toLowerCase().startsWith('fast')) {
        listRole.push(val);
      }
    }
    listRole = _.uniqBy(listRole);
    this.roleName = listRole.join(',');
    console.log(this.roleName, this.roleName);
    this.getUserRoleDetails();
    this.dataTrans.setAssessmentClicked('');
    this.dataTrans.isViewReportClicked = 'false';
    this.dataTrans.requestStatusForReport = null;
    this.getColumnCustomization();
    this.settings = {
      singleSelection: false,
      idField: 'fieldName',
      textField: 'fieldDescription',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      allowSearchFilter: true,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Column to add',
      closeDropDownOnSelection: true,
      itemsShowLimit: 2
    };
  }
  /* istanbul ignore next */
  sendRequestId(user) {
    this.dataTrans.updateRequestId(user);
  }
  /* istanbul ignore next */
  getColumnCustomization() {
    this.loading = true;
    const apiurl = environment.APIFAsT + '/getcolumncustomization/newworklist';
    this.worklistservice.getWorklistApiData(apiurl).subscribe((response) => {
      this.worklistColumnsCustomisedToShow = response;
      this.getWorklistColumns();
    });
  }
  /* istanbul ignore next */
  getWorklistColumns() {
    const apiurl = environment.APIFAsT + '/getworklistcolumns/newworklist';
    this.worklistservice.getWorklistApiData(apiurl).subscribe((response) => {
      this.allWorklistColumns = response;
      this.getWorkList();
    });

    const apiurlworklist = environment.APIFAsT + '/getworklistcolumns/worklist';
    this.worklistservice.getWorklistApiData(apiurlworklist).subscribe((response) => {
      this.orgWorklistColumns = response;
    });
  }
  /* istanbul ignore next */
  initiateColumnOptions() {
    this.columnsAdded = [];
    this.columnListToAdd = this.orgWorklistColumns;
    if (this.worklistColumnsCustomisedToShow.length) {
      this.columnsAdded = this.worklistColumnsCustomisedToShow;
      WORKLIST_EXCEL_ADDITIONAL_COLUMNS.forEach(col => {
        this.columnsAdded = this.columnsAdded.filter(x => x.fieldName !== col.fieldName);
      });
      WORKLIST_EXCEL_ADDITIONAL_COLUMNS_REPORT.forEach(col => {
        this.columnsAdded = this.columnsAdded.filter(x => x.fieldName !== col.fieldName);
      });
    } else {
      this.allWorklistColumns.forEach(column => {
        if (column.fieldName === 'check' ||
          column.fieldName === 'requestDisplayID' || column.fieldName === 'requestStatus'
        ) {
          this.columnsAdded.push(column);
        }
      });
    }
    this.columnsAdded.forEach(col => {
      this.columnListToAdd = this.columnListToAdd.filter(x => x.fieldName !== col.fieldName);
    });
    WORKLIST_EXCEL_ADDITIONAL_COLUMNS.forEach(col => {
      this.columnListToAdd = this.columnListToAdd.filter(x => x.fieldName !== col.fieldName);
    });
    WORKLIST_EXCEL_ADDITIONAL_COLUMNS_REPORT.forEach(col => {
      this.columnListToAdd = this.columnListToAdd.filter(x => x.fieldName !== col.fieldName);
    });
    if (this.columnListToAdd.length > 0) {
      this.addColumnButton = false;
    } else if (this.columnListToAdd.length < 1) {
      this.addColumnButton = true;
    }
  }

  getWorkList() {
    this.masterWorklistTableColumns = [];
    this.masterWorklistColumnsOptions = [];
    if (this.worklistColumnsCustomisedToShow.length) {
      this.masterWorklistTableColumns = this.worklistColumnsCustomisedToShow;
      this.masterWorklistTableExcelColumns = this.worklistColumnsCustomisedToShow;
    } else {
      this.masterWorklistTableColumns = this.allWorklistColumns;
      this.masterWorklistTableExcelColumns = this.orgWorklistColumns;
    }
    /* Frozen-Column Code */
    this.frozenColsInWorklist = this.masterWorklistTableColumns.filter(obj =>
      obj.fieldName === 'requestDisplayID' || obj.fieldName === 'requestStatus');
    this.masterWorklistTableColumns = this.masterWorklistTableColumns.filter(obj =>
      obj.fieldName !== 'requestDisplayID' && obj.fieldName !== 'requestStatus');

    if (this.masterWorklistTableColumns && this.masterWorklistTableColumns.length > 0) {
      this.masterWorklistTableColumns.sort((a3, b3) => (a3.sortOrder > b3.sortOrder) ? 1 : -1);
      const sortedData = this.masterWorklistTableColumns;
      this.masterWorklistTableColumns = sortedData;
      this.masterWorklistTableColumns = JSON.parse(JSON.stringify(this.masterWorklistTableColumns));
    }
    this.loading = true;
    this.loadingWorklistMessage = 'Getting Worklist Details';
    const searchTermPayload = this.buildSearchTerm();
    const requestPayload = this.buildWorklistRequestPayload(
      false,
      this.pageNumber,
      this.pageRecordsLimit,
      searchTermPayload
    );
    const apiurl = environment.APIFAsT + '/execution/requests/workList';
    const fallbackApiurl = environment.APIFAsT + '/execution/requests/noDate/masterworklist';
    const worklistRequest = this.worklistservice.postData(apiurl, requestPayload);
    const worklistObservable = worklistRequest || this.worklistservice.getWorklistApiData(fallbackApiurl);
    worklistObservable.subscribe((response) => {
      const responseData = Array.isArray(response) ? response : ((response && response.workList) || []);
      const totalCount = Array.isArray(response)
        ? response.length
        : ((response && (response.totalSearchResults || response.totalSearchResultCount || response.totalResultCount || response.totalRecords)) || responseData.length);
      this.totalSearchResults = Number(totalCount) || 0;

      const backendTotalPages = Array.isArray(response) ? 0 : Number(response && response.totalPages);
      const computedTotalPages = this.pageRecordsLimit > 0 ? Math.ceil(this.totalSearchResults / this.pageRecordsLimit) : 0;
      this.totalPages = backendTotalPages && backendTotalPages > 0 ? backendTotalPages : computedTotalPages;
      this.emptyworklistmessage = '';
      this.loading = false;
      if (responseData.length !== 0) {
        this.masterWorkListData = responseData.map(respElm => this.mapMasterWorklistRow(respElm));
        this.selectedRows = this.masterWorkListData;
        this.selectedRows = JSON.parse(JSON.stringify(this.masterWorkListData));
        this.filteredRows = Object.keys(this.searchTerm).length > 0 ? JSON.parse(JSON.stringify(this.masterWorkListData)) : [];
        this.applyDateFormatting(this.selectedRows);
        this.exportAllRows = JSON.parse(JSON.stringify(this.selectedRows));
        this.exportFilteredRows = JSON.parse(JSON.stringify(this.filteredRows));
      } else {
        this.loading = false;
        this.emptyworklistmessage = 'No Records Found';
        this.masterWorkListData = [];
        this.filteredRows = [];
        this.exportAllRows = [];
        this.exportFilteredRows = [];
      }
    }, (error) => {
      this.emptyworklistmessage = 'No Records Found';
      this.loading = false;
      this.totalSearchResults = 0;
      this.totalPages = 0;
    });
    this.dataTrans.isViewReportClicked = 'false';
  }

  buildSearchTerm(): { [key: string]: string } {
    const searchTermPayload: { [key: string]: string } = {};
    Object.keys(this.searchTerm).forEach(key => {
      const searchValue = this.searchTerm[key];
      if (searchValue !== undefined && searchValue !== null && String(searchValue).trim() !== '') {
        searchTermPayload[this.getSearchTermKey(key)] = String(searchValue).trim();
      }
    });
    return searchTermPayload;
  }

  getSearchTermKey(fieldName: string) {
    return WORKLIST_SEARCH_TERM_FIELD_MAP[fieldName] || fieldName;
  }

  buildSearchParams(searchTermPayload: { [key: string]: string }) {
    const searchParams = Object.keys(searchTermPayload).map((fieldName) => ({
      FieldName: fieldName,
      FieldValue: searchTermPayload[fieldName]
    }));
    return searchParams.length > 0 ? searchParams : null;
  }

  onSearchTermChange(fieldName: string, value: string) {
    this.searchInput[fieldName] = value;
  }

 onSearchTermApply(fieldName: string) {
    // Sync every box's current text, not just the field that triggered apply, so
    // text typed into other filters isn't dropped/ignored when Enter is pressed elsewhere
    Object.keys(this.searchInput).forEach(key => {
      const value = this.searchInput[key];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        this.searchTerm[key] = String(value).trim();
      } else {
        delete this.searchTerm[key];
      }
    });
    this.pageNumber = 1;
    this.getWorkList();
  }

  loadMasterWorklist(event: any) {
    this.pageRecordsLimit = event && event.rows ? event.rows : this.pageRecordsLimit;
    const first = event && event.first ? event.first : 0;
    this.pageNumber = Math.floor(first / this.pageRecordsLimit) + 1;
    this.sortField = event && event.sortField ? event.sortField : '';
    this.sortOrder = event && event.sortOrder ? event.sortOrder : 1;
    this.getWorkList();
  }

  buildWorklistRequestPayload(
    isExportSelected: boolean,
    pageNumber: number,
    pageRecordsLimit: number,
    searchTermPayload: { [key: string]: string }
  ) {
    return {
      workListType: 'masterworklist',
      pageNumber,
      pageRecordsLimit,
      sortByColumn: this.sortField ? this.getSearchTermKey(this.sortField) : '',
      sortType: this.sortField ? (this.sortOrder === 1 ? 'asc' : 'desc') : '',
      searchTerm: searchTermPayload,
      SearchParam: this.buildSearchParams(searchTermPayload),
      totalSearchResults: this.totalSearchResults,
      totalPages: this.totalPages,
      workList: null,
      IsExportSelected: isExportSelected
    };
  }

  applyDateFormatting(rows: any[]) {
    rows.forEach(el => {
      el.keyDate = el.keyDate ? this.datePipe.transform(new Date(el.keyDate), 'dd-MM-yyyy') : '';
      el.assignedDate = el.assignedDate ? this.datePipe.transform(new Date(el.assignedDate), 'dd-MM-yyyy') : '';
      el.reSubmittedDate = el.reSubmittedDate ? this.datePipe.transform(new Date(el.reSubmittedDate), 'dd-MM-yyyy') : '';
      el.sentBackDate = el.sentBackDate ? this.datePipe.transform(new Date(el.sentBackDate), 'dd-MM-yyyy') : '';
      el.submittedDate = el.submittedDate ? this.datePipe.transform(new Date(el.submittedDate), 'dd-MM-yyyy') : '';
      el.launchTimeLine = el.launchTimeLine ? this.datePipe.transform(new Date(el.launchTimeLine), 'dd-MM-yyyy') : '';
      el.inProgressRADate = el.inProgressRADate ? this.datePipe.transform(new Date(el.inProgressRADate), 'dd-MM-yyyy') : '';
      el.inProgressRDDate = el.inProgressRDDate ? this.datePipe.transform(new Date(el.inProgressRDDate), 'dd-MM-yyyy') : '';
      el.inProgressSIRDate = el.inProgressSIRDate ? this.datePipe.transform(new Date(el.inProgressSIRDate), 'dd-MM-yyyy') : '';
      el.rejectedDate = el.rejectedDate ? this.datePipe.transform(new Date(el.rejectedDate), 'dd-MM-yyyy') : '';
      el.deletionDate = el.deletionDate ? this.datePipe.transform(new Date(el.deletionDate), 'dd-MM-yyyy') : '';
      el.completedDate = el.completedDate ? this.datePipe.transform(new Date(el.completedDate), 'dd-MM-yyyy') : '';
      el.completedRndDate = el.completedRndDate ? this.datePipe.transform(new Date(el.completedRndDate), 'dd-MM-yyyy') : '';
    });
  }

  onFilter(event) {
    if (event.filters != null) {
      Object.keys(event.filters).length === 0
        ? (this.filteredRows = [])
        : (this.filteredRows = event.filteredValue);
      this.filteredRows = JSON.parse(JSON.stringify(this.filteredRows));
      this.filteredRows.forEach(el => {
        el.keyDate = el.keyDate ? this.datePipe.transform(new Date(el.keyDate), 'dd-MM-yyyy') : '';
        el.assignedDate = el.assignedDate ? this.datePipe.transform(new Date(el.assignedDate), 'dd-MM-yyyy') : '';
        el.reSubmittedDate = el.reSubmittedDate ? this.datePipe.transform(new Date(el.reSubmittedDate), 'dd-MM-yyyy') : '';
        el.sentBackDate = el.sentBackDate ? this.datePipe.transform(new Date(el.sentBackDate), 'dd-MM-yyyy') : '';
        el.submittedDate = el.submittedDate ? this.datePipe.transform(new Date(el.submittedDate), 'dd-MM-yyyy') : '';
        el.launchTimeLine = el.launchTimeLine ? this.datePipe.transform(new Date(el.launchTimeLine), 'dd-MM-yyyy') : '';
        el.inProgressRADate = el.inProgressRADate ? this.datePipe.transform(new Date(el.inProgressRADate), 'dd-MM-yyyy') : '';
        el.inProgressRDDate = el.inProgressRDDate ? this.datePipe.transform(new Date(el.inProgressRDDate), 'dd-MM-yyyy') : '';
        el.inProgressSIRDate = el.inProgressSIRDate ? this.datePipe.transform(new Date(el.inProgressSIRDate), 'dd-MM-yyyy') : '';
        el.rejectedDate = el.rejectedDate ? this.datePipe.transform(new Date(el.rejectedDate), 'dd-MM-yyyy') : '';
        el.deletionDate = el.deletionDate ? this.datePipe.transform(new Date(el.deletionDate), 'dd-MM-yyyy') : '';
        el.completedDate = el.completedDate ? this.datePipe.transform(new Date(el.completedDate), 'dd-MM-yyyy') : '';
        el.completedRndDate = el.completedRndDate ? this.datePipe.transform(new Date(el.completedRndDate), 'dd-MM-yyyy') : '';
      });
    }
  }
  showExportDialog() {
    if (this.worklistColumnsCustomisedToShow.length) {
      this.masterWorklistTableExcelColumns = this.worklistColumnsCustomisedToShow;
    } else {
      this.masterWorklistTableExcelColumns = this.orgWorklistColumns;
    }
    // this.masterWorklistTableExcelColumns = this.orgWorklistColumns;
    const rdHashyerlinks = this.masterWorklistTableExcelColumns.filter(x => x.fieldName === 'rdComment').length > 0 ? 'Yes' : 'No';
    const reportHashyerlinks = this.masterWorklistTableExcelColumns.filter(x => x.fieldName === 'reportComments').length > 0 ? 'Yes' : 'No';
    if (rdHashyerlinks === 'Yes' || reportHashyerlinks === 'Yes') {
      this.isColumnsHasHyperLinks = 'Yes';
    } else {
      this.isColumnsHasHyperLinks = 'No';
    }
    if (this.isColumnsHasHyperLinks === 'Yes') {
      let totalHyperlinksCount = 0;
      if (this.masterWorklistTableExcelColumns.filter(x => x.fieldName === 'rdcommentLink1').length === 0 && rdHashyerlinks === 'Yes') {
        this.addExtraColumns();
      }
      if (this.masterWorklistTableExcelColumns.filter(x => x.fieldName === 'reportCommentsLink1').length === 0 && reportHashyerlinks === 'Yes') {
        this.addExtraColumnsReport();
      }
      if (rdHashyerlinks === 'Yes') {
        totalHyperlinksCount = this.masterWorklistTableExcelColumns.findIndex(x => x.fieldName === 'rdcommentLink1');
      } else if (reportHashyerlinks === 'Yes' && totalHyperlinksCount === 0) {
        totalHyperlinksCount = this.masterWorklistTableExcelColumns.findIndex(x => x.fieldName === 'reportCommentsLink1');
      }
      this.HyperLinksStartColumnNumber = totalHyperlinksCount + 1;
    }
    this.exportDialog = true;
  }

  hasActiveFilters() {
    return Object.keys(this.searchTerm).length > 0;
  }

  onExportAll(exportButton: ExportExcelButtonComponent) {
    this.fetchExportRows(false, exportButton);
  }

  onExportFiltered(exportButton: ExportExcelButtonComponent) {
    this.fetchExportRows(true, exportButton);
  }

  fetchExportRows(isFilteredExport: boolean, exportButton: ExportExcelButtonComponent) {
    const exportPageLimit = this.totalSearchResults > 0 ? this.totalSearchResults : this.pageRecordsLimit;
    let requestPayload;
    if (isFilteredExport) {
      const searchTermPayload = this.buildSearchTerm();
      requestPayload = this.buildWorklistRequestPayload(true, 1, exportPageLimit, searchTermPayload);
    } else {
      requestPayload = this.buildWorklistRequestPayload(true, 1, exportPageLimit, {});
    }
    const apiurl = environment.APIFAsT + '/execution/requests/workList';
    this.loading = true;
    this.loadingWorklistMessage = isFilteredExport ? 'Exporting Filtered Worklist' : 'Exporting Worklist';
    this.worklistservice.postData(apiurl, requestPayload).subscribe((response) => {
      const responseData = Array.isArray(response) ? response : ((response && response.workList) || []);
      const exportRows = responseData.map(respElem => this.mapMasterWorklistRow(respElem));
      const formattedExportRows = JSON.parse(JSON.stringify(exportRows));
      this.applyDateFormatting(formattedExportRows);
      if (isFilteredExport) {
        this.exportFilteredRows = formattedExportRows;
        exportButton.rowsData = this.exportFilteredRows;
      } else {
        this.exportAllRows = formattedExportRows;
        exportButton.rowsData = this.exportAllRows;
      }
      this.loading = false;
      exportButton.exportToExcel();
    }, () => {
      this.loading = false;
    });
  }

  mapMasterWorklistRow(respElm: any) {
    this.changeComment(respElm);
    this.splitLinks(respElm.comments, 'comment');
    this.splitLinksReport(respElm.reportComments, 'Reportcomment');
    const marketId = respElm.market.marketId;
    const reqCategoryID = (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.parentTFC.tfcId : respElm.tfc.parentTFC.parentTFC.tfcId;
    const divisionId = (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcId : respElm.tfc.parentTFC.parentTFC.parentTFC.tfcId;
    const nonPlmReq = respElm.recipeStatus === '000' ? true : false;
    return {
      requestDisplayID: respElm.requestDisplayID,
      cucCode: nonPlmReq ? respElm.cucCode.replace('//', '/') : respElm.cucCode,
      cucDescription: respElm.cucDescription,
      keyDate: respElm.keyDate !== '0001-01-01T00:00:00' ? respElm.keyDate : '',
      requestNotification: respElm.requestNotification,
      validityArea: nonPlmReq ? '' : respElm.validityArea,
      recipeType: nonPlmReq ? 'FAsT RECIPE' : respElm.recipeType,
      recipeStatus: nonPlmReq ? '' : respElm.recipeStatus,
      marketId: respElm.market.marketId,
      marketName: respElm.market.marketName,
      projectName: respElm.market.projDetail === null || respElm.market.projDetail === undefined ? '' : respElm.market.projDetail.projectName,
      projectDescription: respElm.market.projDetail === null || respElm.market.projDetail === undefined ? '' : respElm.market.projDetail.projectDescription,
      projectTypeDesc: respElm.market.projDetail === null || respElm.market.projDetail === undefined ? '' : respElm.market.projDetail.projectTypeDesc,
      brandDesc: respElm.market.projDetail === null || respElm.market.projDetail === undefined ? '' : respElm.market.projDetail.brandDesc,
      launchTimeLine: respElm.market.projDetail === null || respElm.market.projDetail === undefined || respElm.market.projDetail.launchTimeLine !== '1900-01-01T00:00:00' ? respElm.market.projDetail.launchTimeLine : '',
      manufactureCountryDescription: respElm.market.projDetail === null || respElm.market.projDetail === undefined ? '' : respElm.market.projDetail.manufactureCountryDescription,
      manufactureSiteDesc: respElm.market.projDetail === null || respElm.market.projDetail === undefined ? '' : respElm.market.projDetail.manufactureSiteDesc,
      '1ULMarket': (respElm.market && respElm.market.oneUnileverName && respElm.market.oneUnileverName !== '') ? respElm.market.oneUnileverName : '',
      division: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcName : respElm.tfc.parentTFC.parentTFC.parentTFC.tfcName,
      updId: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcId : respElm.tfc.parentTFC.parentTFC.parentTFC.tfcId,
      rDFormulationCategoryId: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.parentTFC.tfcId : respElm.tfc.parentTFC.parentTFC.tfcId,
      rDFormulationCategory: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.parentTFC.tfcName : respElm.tfc.parentTFC.parentTFC.tfcName,
      formulationType: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.parentTFC.tfcName : respElm.tfc.parentTFC.tfcName,
      formulationClass: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.parentTFC.tfcName : respElm.tfc.tfcName,
      formulationSubClass: (respElm.tfc.tfcLevel === 5) ? respElm.tfc.tfcName : '',
      preparationMethod: respElm.preparationMethod,
      intendedUse: respElm.intendedUse,
      multicomponent: respElm.isMultiComponent,
      requestStatus: respElm.requestStatus,
      ra: respElm.ra,
      allRa: respElm.allRA,
      submittedDate: respElm.submittedDate !== '0001-01-01T00:00:00' ? respElm.submittedDate : '',
      submittedByUserId: respElm.submittedByUserId,
      submittedByUserName: respElm.submittedByUserName,
      comments: respElm.comments,
      assignedDate: respElm.assignedDate !== '0001-01-01T00:00:00' ? respElm.assignedDate : '',
      inProgressRADate: respElm.inProgressRADate !== '0001-01-01T00:00:00' ? respElm.inProgressRADate : '',
      inProgressRDDate: respElm.inProgressRNDDate !== '0001-01-01T00:00:00' ? respElm.inProgressRNDDate : '',
      inProgressSIRDate: respElm.inProgressSIRDate !== '0001-01-01T00:00:00' ? respElm.inProgressSIRDate : '',
      rejectedDate: respElm.rejectedDate !== '0001-01-01T00:00:00' ? respElm.rejectedDate : '',
      deletionDate: respElm.deletionDate !== '0001-01-01T00:00:00' ? respElm.deletionDate : '',
      completedDate: respElm.completedDate !== '0001-01-01T00:00:00' ? respElm.completedDate : '',
      completedRndDate: respElm.completedRndDate !== '0001-01-01T00:00:00' ? respElm.completedRndDate : '',
      completedRndBy: respElm.completedRndBy === null || respElm.completedRndBy === undefined ? '' : respElm.completedRndBy,
      unileverInternational: (respElm.unileverInternational === true ||
        (respElm.market && respElm.market.projDetail && respElm.market.projDetail.unileverInternational === true)) ? 'UI' : '',
      rdComment: this.commentRD,
      raComment: respElm.raComment,
      reportComments: respElm.reportComments === null || respElm.reportComments === undefined || respElm.reportComments === '' ? '' : 'RA Comment',
      rpcomments: respElm.reportComments === null || respElm.reportComments === undefined || respElm.reportComments === '' ? '' : 'RA Comment',
      topTfcId: respElm.tfcid,
      allRAIDs: respElm.allRAIDs,
      raUserID: respElm.raUserID,
      sentBackDate: respElm.sentBackDate !== '0001-01-01T00:00:00' ? respElm.sentBackDate : '',
      reSubmittedDate: respElm.reSubmittedDate !== '0001-01-01T00:00:00' ? respElm.reSubmittedDate : '',
      compositionStatus: respElm.compositionStatus,
      productStatus: nonPlmReq ? '' : respElm.productStatus,
      rdcommentLink1: this.CommentsHyperLinks[0],
      rdcommentLink2: this.CommentsHyperLinks[1],
      rdcommentLink3: this.CommentsHyperLinks[2],
      rdcommentLink4: this.CommentsHyperLinks[3],
      rdcommentLink5: this.CommentsHyperLinks[4],
      rdcommentLink6: this.CommentsHyperLinks[5],
      rdcommentLink7: this.CommentsHyperLinks[6],
      reportCommentsLink1: this.ReportCommentsHyperLinks[0],
      reportCommentsLink2: this.ReportCommentsHyperLinks[1],
      reportCommentsLink3: this.ReportCommentsHyperLinks[2],
      reportCommentsLink4: this.ReportCommentsHyperLinks[3],
      reportCommentsLink5: this.ReportCommentsHyperLinks[4],
      reportCommentsLink6: this.ReportCommentsHyperLinks[5],
      reportCommentsLink7: this.ReportCommentsHyperLinks[6],
      rdPlainComment: this.handleSpecialCharacters(respElm.comments),
      PlainReportComment: this.handleSpecialCharacters(respElm.reportComments),
      tfc1status: respElm.tfc1status,
      selfAssignRequest: this.getActionStatusBasedonRole(marketId, divisionId, 'selfAssignRequest', reqCategoryID),
      delegateRequest: this.getActionStatusBasedonRole(marketId, divisionId, 'delegateRequest', reqCategoryID),
      forwardtoRaRequest: this.getActionStatusBasedonRole(marketId, divisionId, 'forwardtoRaRequest', reqCategoryID),
      rejectRequest: this.getActionStatusBasedonRole(marketId, divisionId, 'rejectRequest', reqCategoryID),
      isPlm: nonPlmReq ? false : true,
      recipeID: respElm.cucCode.slice(0, 11),
      instantReportFlg: respElm.instantReportFlg,
      requestMarketID: respElm.requestMarketID,
      businessGroupName: respElm.businessGroupName
    };
  }
  redirectTo(request: any) {
    this.sendRequestId(request);
    let formulationData = [];
    const pureCodeList = [];
    if (request.requestStatus === 'In Progress – R&D') {
      recipeModel.requestStatus = request.requestStatus;
      const apiurl = environment.APIFAsT + '/executionrequest/' + request.requestDisplayID;
      this.assessraService.getData(apiurl).subscribe((response) => {
        if (response !== null) {
          Object.assign(recipeModel, response);
          recipeModel.marketDetails = response.marketDetails;
          recipeModel.tfcFullText = response.tfc.tfcFullText;
          if (response.tfc.tfcLevel === 5) {
            recipeModel.formulationSubClass = response.tfc.tfcName;
            const tfc5parent = response.tfc.parentTFC;
            if (tfc5parent.tfcLevel === 4) {
              recipeModel.formulationClass = tfc5parent.tfcName;
              const tfc4parent = tfc5parent.parentTFC;
              if (tfc4parent.tfcLevel === 3) {
                recipeModel.formulationType = tfc4parent.tfcName;
                const tfc3parent = tfc4parent.parentTFC;
                if (tfc3parent.tfcLevel === 2) {
                  recipeModel.formulationCategory = tfc3parent.tfcName;
                  const tfc2parent = tfc3parent.parentTFC;
                  if (tfc2parent.tfcLevel === 1) {
                    recipeModel.division = tfc2parent.tfcName;
                  }
                }
              }
            }
          }
          formulationData = response.formulationRequestDetails;
          if (formulationData) {
            for (let i = 0; i < formulationData.length; i++) {
              pureCodeList[i] = formulationData[i].pureCode;
            }
            recipeModel.pureCodeList = pureCodeList;
          }
          this.dataTrans.setComponentName('AssessRequestsRA');
          this.dataTrans.setSelectedStep(2);
          this.worklistservice.setProfileObs(request.requestDisplayID);
          this.router.navigate(['assess-request-ra/execute-rules']);
        }
      });
    } else {
      this.dataTrans.setComponentName('AssessRequestsRA');
      recipeModel.requestStatus = request.requestStatus;
      recipeModel.allRAIDs = request.allRAIDs;
      recipeModel.raUserID = request.raUserID;
      recipeModel.ra = request.ra;
      if (request !== null) {
        const val: any = {
          requestID: request.requestDisplayID,
          requestStatus: request.requestStatus
        };
        this.worklistservice.setRecipeData(val);
      }
      const url = '/assess-request-ra/verify-request/' + request.requestDisplayID;
      this.router.navigate([url]);
      this.worklistservice.setProfileObs(request.requestDisplayID);
      localStorage.setItem('submittedByUserId', request.submittedByUserId);
    }
  }
  /* istanbul ignore next */
  showFloatingIcons(event, rowData) {
    this.selectedRowData = rowData;
    event.target.dataTypeElem = 'row';
    this.flotingDivFlag = true;
    this.rowData = rowData;
    setTimeout(() => {
      const d = document.getElementById('rowHoverDiv');
      const adj = (window.screen.width === window.outerWidth) ? 0 : -15;
      const maxScreenWidth = window.innerWidth * (window.screen.width / (window.outerWidth + adj));
      d.style.left = String(event.pageX + 15) + 'px';
      d.style.display = 'block';
      this.masterWLActionCount = d.getElementsByTagName('input').length;
      if (this.masterWLActionCount === 0) {
        d.style.display = 'none';
      }
      if (event.pageY > 400) {
        if (this.masterWLActionCount === 1) {
          d.style.top = (event.pageY - 20) + 'px';
        } else if (this.masterWLActionCount === 2) {
          d.style.top = (event.pageY - 45) + 'px';
        } else if (this.masterWLActionCount === 3) {
          d.style.top = (event.pageY - 70) + 'px';
        } else if (this.masterWLActionCount === 4) {
          d.style.top = (event.pageY - 95) + 'px';
        } else if (this.masterWLActionCount === 5) {
          d.style.top = (event.pageY - 120) + 'px';
        }
      } else {
        d.style.top = (event.pageY - 10) + 'px';
      }
    }, 100);
  }

  hideFloatingIcons() {
    this.rowHoverDiv.nativeElement.style.display = 'none';
  }

  mousehoverpop(event) {
    event.stopPropagation();
  }

  assignRequest(event) {
    if (this.selectedRowData.requestStatus === 'Submitted' || this.selectedRowData.requestStatus === 'Re-Submitted' || ((this.isRA || this.isSuperAdmin) && this.selectedRowData.requestStatus === 'Completed - R&D')) {
      this.assignToSelf(this.selectedRowData.requestDisplayID, this.selectedRowData.submittedByUserId, this.selectedRowData.cucDescription);
    } else {
      this.matSnackBar.open(this.selectedRowData.requestStatus + ' Request cannot be Self Assign', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
    }

    event.stopPropagation();
    return false;
  }
  assignToSelf(requestId, requestCreatedById, cucDescription) {
    const selfAssignApiBody = {
      RequestId: requestId,
      UserId: 0,
      AssignmentType: 'Self-Assign'
    };
    this.loading = true;
    this.loadingWorklistMessage = 'Assigning Request';

    const apiurl = environment.APIFAsT + '/assignnassessmentrequest/self';
    this.worklistservice.selfAssignApi(apiurl, selfAssignApiBody).subscribe((response) => {
      this.loading = false;
      if (response.result === 'Success') {

        this.sendResponseEmail('Assign', requestId, requestCreatedById, '', '', cucDescription, cucDescription, this.selectedRowData.recipeID, this.selectedRowData.isPlm, '');
        this.selfAssignPopUp = true;
      }
    }, (error) => {
      this.loading = false;
    });
    if (this.selectedRowData.requestStatus === 'Completed - R&D') {
      // Clear Composition Status and product status of this request after self assign, if the Requeststatus is Completed - R&D
      this.clearCompostionAndProductStatus();
    }
  }

  // CG - Send response email to respective RA/R&D users.
  sendResponseEmail(notificationGroup, displayRequestId, toemailids, bodyData, ccemaillist, cucDescription, recipeDescription = '', recipeID = '', isPlm = false, message) {
    const data = {
      NotificationGroup: notificationGroup,
      Subject: null,
      EmailBody: bodyData,
      ToEmailList: toemailids,
      FromEmail: null,
      CCEmailList: ccemaillist,
      EmailType: 'html',
      UPD: this.selectedRowData.updId,
      PureCodes: null,
      RequestID: displayRequestId,
      CUCDescription: cucDescription,
      MarketId: this.selectedRowData.marketId,
      RecipeDescription: recipeDescription,
      RecipeID: this.selectedRowData.cucCode,
      IsPLMRequest: isPlm,
      MarketName: this.selectedRowData.marketName,
      ValidationMessage: message,
      Division: this.selectedRowData.division,
      CategoryID: this.selectedRowData.rDFormulationCategoryId
    };
    const apiurl = environment.APIFAsT + '/responseemail';
    this.worklistservice.postData(apiurl, data).subscribe((response) => {
      this.loading = false;
      if (response.result === 'Success') {
        if (notificationGroup === 'Assign') {
        }
      }
    }, (error) => {
      this.loading = false;
    });
  }

  forwardToRARequest(event) {
    if (this.selectedRowData.requestStatus !== 'Deleted' && this.selectedRowData.requestStatus !== 'Rejected'
      && this.selectedRowData.requestStatus !== 'Completed') {
      this.delegateORForward = 'forward';
      this.getUsersForCountryAndDivision();
    } else {
      this.matSnackBar.open(this.selectedRowData.requestStatus + ' Request cannot be Forward To RA', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
    }
    event.stopPropagation();
    return false;
  }

  deleteRequest(event) {
    this.rejectionComments = '';
    if (this.selectedRowData.requestStatus === 'Assigned') {
      this.deleteDialog = true;
    } else {
      this.matSnackBar.open(this.selectedRowData.requestStatus + ' Request cannot Rejected..', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
    }
    event.stopPropagation();
    return false;
  }

  completeRequest(event) {
    this.dataTrans.isViewReportClicked = 'true';
    this.dataTrans.requestStatusForReport = 'Completed';
    this.dataTrans.setComponentName('SubmitReportRA');
    this.loadingWorklistMessage = 'Getting FAsT Report';
    const apiurl = environment.APIFAsT + '/reportrequest/' + this.selectedRowData.requestDisplayID;
    this.loading = true;
    this.worklistservice.getData(apiurl).subscribe((response1) => {
      if (response1 !== null) {
        const val: any = {
          requestID: response1.requestDisplayID,
          requestStatus: response1.requestStatus
        };
        this.worklistservice.setRecipeData(val);
        recipeModel.requestDisplayID = response1.requestDisplayID;
        this.sendRequestId(response1);
        this.dataTrans.completedReport = response1;
        this.dataTrans.setSelectedStep(3);
        setTimeout(() => {
          this.router.navigate(['assess-request-ra/submit-report']);
        }, 500);
      }
      this.loading = false;
    }, (error) => {
      this.loading = false;
    });
  }

  delegateRequest(event) {
    if (this.selectedRowData.requestStatus !== 'Deleted' && this.selectedRowData.requestStatus !== 'Rejected'
      && this.selectedRowData.requestStatus !== 'Completed') {
      this.delegateORForward = 'delegate';
      this.getUsersForCountryAndDivision();
    } else {
      this.matSnackBar.open(this.selectedRowData.requestStatus + ' Request cannot be Delegated', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
    }
    event.stopPropagation();
    return false;
  }

  onDelegate() {
    if (this.selectedRowData.requestStatus === 'Completed - R&D') {
      this.clearCompostionAndProductStatus();
    }
    this.listOfEmails.push(this.deligatOrForwardEmailId);
    const delegateApiBody = {
      AssignmentType: 'Delegate',
      RequestId: this.selectedRowData.requestDisplayID,
      DelegatOrForwardEmailIds: this.listOfEmails,
      DelegatOrForwardComment: this.deligateComment
    };
    const statusUpdateApiUrl = environment.APIFAsT + '/assignnassessmentrequest/delegate';
    this.loading = true;
    this.loadingWorklistMessage = 'Request Delegating';

    this.worklistservice.postData(statusUpdateApiUrl, delegateApiBody).subscribe((statusresponse) => {
      this.loading = false;
      if (statusresponse.result === 'Success') {

        this.sendResponseEmail(delegateApiBody.AssignmentType, delegateApiBody.RequestId, delegateApiBody.DelegatOrForwardEmailIds[0], delegateApiBody.DelegatOrForwardComment, this.selectedRowData.submittedByUserId, this.selectedRowData.cucDescription, this.selectedRowData.cucDescription, this.selectedRowData.recipeID, this.selectedRowData.isPlm, '');
        this.matSnackBar.open('Request ' + this.selectedRowData.requestDisplayID + ' Delegated succesfully', 'close', {
          duration: 3200,
          panelClass: ['success']
        });
      } else {
        this.matSnackBar.open(statusresponse.result, 'close', {
          duration: 3200,
          panelClass: ['error']
        });
      }
      this.getWorkList();
      this.listOfEmails = [];
      this.deligatOrForwardEmailId = null;
    }, (error) => {
      this.loading = false;
    });
  }

  onForwardToRa() {
    if (this.selectedRowData.requestStatus === 'Completed - R&D') {
      this.clearCompostionAndProductStatus();
    }
    this.listOfEmails.push(this.deligatOrForwardEmailId);
    const delegateApiBody = {
      AssignmentType: 'ForwardToRA',
      RequestId: this.selectedRowData.requestDisplayID,
      DelegatOrForwardEmailIds: this.listOfEmails,
      DelegatOrForwardComment: this.forwardToRaComment
    };
    const statusUpdateApiUrl = environment.APIFAsT + '/assignnassessmentrequest/forward';
    this.loading = true;
    this.loadingWorklistMessage = 'Request forwarding';
    this.worklistservice.postData(statusUpdateApiUrl, delegateApiBody).subscribe((statusresponse) => {
      this.loading = false;
      if (statusresponse.result === 'Success') {

        this.sendResponseEmail('forward', delegateApiBody.RequestId, delegateApiBody.DelegatOrForwardEmailIds[0], delegateApiBody.DelegatOrForwardComment, this.selectedRowData.submittedByUserId, this.selectedRowData.cucDescription, this.selectedRowData.cucDescription, this.selectedRowData.recipeID, this.selectedRowData.isPlm, '');
        this.matSnackBar.open('Request ' + this.selectedRowData.requestDisplayID + ' forwarded succesfully', 'close', {
          duration: 3200,
          panelClass: ['success']
        });
      } else {
        this.matSnackBar.open(statusresponse.result, 'close', {
          duration: 3200,
          panelClass: ['error']
        });
      }
      this.getWorkList();
      this.listOfEmails = [];
      this.deligatOrForwardEmailId = null;
    }, (error) => {
      this.loading = false;
    });
  }

  onDeleteRequest() {
    const requestStatus = 'Rejected';
    const statusUpdateApiUrl = environment.APIFAsT + '/assessment/request/' + this.selectedRowData.requestDisplayID + '/status/' + requestStatus + '/comment/' + this.rejectionComments;
    this.loading = true;
    this.loadingWorklistMessage = 'Request Status Update';
    this.worklistservice.putApiData(statusUpdateApiUrl).subscribe((statusresponse) => {
      if (statusresponse.message !== null) {

        this.loading = false;
        this.sendResponseEmail('Reject', this.selectedRowData.requestDisplayID, this.selectedRowData.submittedByUserId, this.rejectionComments, '', this.selectedRowData.cucDescription, this.selectedRowData.cucDescription, this.selectedRowData.recipeID, this.selectedRowData.isPlm, '');
        this.matSnackBar.open(statusresponse.message, 'close', {
          duration: 3200,
          panelClass: ['success']
        });
        this.getWorkList();
      }
    }, (error) => {
      this.loading = false;
    });
  }

  getUsersForCountryAndDivision() {
    this.loadingWorklistMessage = 'Fetching Users';
    this.loading = true;
    this.deligatOrForwardEmailId = null;
    this.forwardToRaComment = '';
    this.deligateComment = '';
    const fetchUserApiUrl = environment.APIFAsT + '/users/market/' + this.selectedRowData.marketId + '/upd/' + this.selectedRowData.topTfcId;
    this.worklistservice.getData(fetchUserApiUrl).subscribe((apiResponse) => {
      this.loading = false;
      if (apiResponse.length !== 0) {
        this.usersList = apiResponse;
      }
      if (this.delegateORForward === 'delegate') {

        this.delegateDialog = true;
      } else if (this.delegateORForward === 'forward') {
        this.forwardToRaPopUp = true;
      }

    }, (error) => {
      this.loading = false;
    });
  }

  searchUsersList(event) {
    const filtered: any[] = [];
    const query = event.query;
    for (const value of this.usersList) {
      this.userValue = value.userEmailId;
      if (this.userValue.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.userValue);
      }
    }
    this.filteredUserListVals = filtered;
    this.validateEmail(this.filteredUserListVals);
  }
  /* istanbul ignore next */
  validateEmail(email) {
    if (email.length === 1 && email[0].endsWith('@unilever.com')) {
      this.deligatOrForwardEmailId = email[0];
      this.delegateOrForwardBtnFlag = false;
    } else {
      this.delegateOrForwardBtnFlag = true;
    }
  }

  onEmailIdClear() {
    this.deligatOrForwardEmailId = null;
    this.filteredUserListVals = [];
    this.delegateOrForwardBtnFlag = true;
  }
  onDropdownSelect(event) {
    this.deligatOrForwardEmailId = event;
    this.filteredUserListVals.push(this.deligatOrForwardEmailId);
    this.delegateOrForwardBtnFlag = false;
  }
  onDelegateCancelClick() {
    this.deligatOrForwardEmailId = null;
    this.delegateDialog = false;
    this.deligateComment = '';
    this.forwardToRaComment = '';
  }
  onForwardCancelClick() {
    this.forwardToRaPopUp = false;
    this.deligatOrForwardEmailId = null;
    this.forwardToRaComment = '';
    this.deligateComment = '';
  }
  /* istanbul ignore next */
  onClearFilters(masterWLTable: any) {
    if (this.worklistColumnsCustomisedToShow.length) {
      this.masterWorklistTableColumnsClear = this.worklistColumnsCustomisedToShow;
    } else {
      this.masterWorklistTableColumnsClear = this.allWorklistColumns;
    }

    masterWLTable.reset();
    this.searchInput = {};
    this.searchTerm = {};
    this.pageNumber = 1;
    this.filteredRows = [];
    for (const val of this.masterWorklistTableColumnsClear) {
      if (val.fieldName !== 'check') {
        const colname = val.fieldName + '_val';
        if ((<HTMLInputElement> document.getElementById(colname)) && (<HTMLInputElement> document.getElementById(colname)).value) {
          (<HTMLInputElement> document.getElementById(colname)).value = '';
        }
      }
    }
    this.getWorkList();
  }
  /* istanbul ignore next */
  selectRow(checkValue) {
    if (checkValue) {
      this.selectedRows = this.masterWorkListData;
    } else {
      this.selectedRows = [];
    }
  }
  onCreateReqBtn() {
    requestFlags.viewRequest = false;
    requestFlags.EditRequest = false;
    requestFlags.createRequest = true;
    this.dataTrans.setComponentName('AssessRequestsRD');
    setTimeout(() => {
      this.dataTrans.setSelectedStep(0);
    }, 200);
    this.router.navigate(['/assess-requests/select-recipe']);
  }
  editRequestCheck() {
    if (this.selectedRowData.requestStatus === 'Submitted' || this.selectedRowData.requestStatus === 'Re-Submitted' || this.selectedRowData.requestStatus === 'SentBack') {
      this.viewOrEditRequest('edit');
    } else {
      this.matSnackBar.open(this.selectedRowData.requestStatus + ' Request cannot be Edited', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
    }
  }

  viewOrEditRequest(type) {
    requestFlags.createRequest = false;
    if (type === 'view') {
      requestFlags.viewRequest = true;
      requestFlags.EditRequest = false;

    } else if (type === 'edit') {
      requestFlags.viewRequest = false;
      requestFlags.EditRequest = true;
    }
    this.loadingWorklistMessage = 'Fetching Request Details';
    const apiurl = environment.APIFAsT + '/executionrequest/' + this.selectedRowData.requestDisplayID;
    this.loading = true;
    this.worklistservice.getData(apiurl).subscribe((response) => {
      if (response !== null) {
        this.worklistSelectedRowData = response;
        this.dataTrans.setCompositionData(this.worklistSelectedRowData.formulationRequestDetails);
        this.dataTrans.setPropertyData(this.worklistSelectedRowData.productPropertiesInputs);
        this.dataTrans.setMultiComponentData(this.worklistSelectedRowData.multiComponent);
        if (this.worklistSelectedRowData.marketDetails) {
          this.dataTrans.setProjectData(this.worklistSelectedRowData.marketDetails.projDetail);
        }
        this.formAssess.requestDisplayID = this.selectedRowData.requestDisplayID;
        this.formAssess.division = this.selectedRowData.division;
        this.formAssess.formulationCategory = this.selectedRowData.rDFormulationCategory;
        this.formAssess.formulationType = this.selectedRowData.formulationType;
        this.formAssess.formulationClass = this.selectedRowData.formulationClass;
        this.formAssess.formulationSubClass = this.selectedRowData.formulationSubClass;
        this.formAssess.fc = this.worklistSelectedRowData.cucCode;
        this.formAssess.alternate = this.worklistSelectedRowData.cucAlt;
        this.formAssess.version = this.worklistSelectedRowData.cucVer;
        this.formAssess.recipeType = this.worklistSelectedRowData.recipeType;
        this.formAssess.description = this.worklistSelectedRowData.cucDescription;
        this.formAssess.businessGroupName = this.worklistSelectedRowData.businessGroupName;
        this.formAssess.nonplmRecipeSource = this.worklistSelectedRowData.nonplmRecipeSource ? this.worklistSelectedRowData.nonplmRecipeSource : '';
        this.formAssess.name = null;
        this.formAssess.uom = null;
        this.formAssess.intendedUse = this.worklistSelectedRowData.intendedUse;
        this.formAssess.prepMethod = this.worklistSelectedRowData.preparationMethod;
        this.formAssess.comments = this.worklistSelectedRowData.requestComments;
        this.formAssess.dosage = this.worklistSelectedRowData.dosage;
        this.formAssess.servingSize = this.worklistSelectedRowData.servingSize;
        this.formAssess.dosageUom = this.worklistSelectedRowData.dosageUnit;
        this.formAssess.selectedMarkets = [this.worklistSelectedRowData.marketDetails];
        this.formAssess.market = this.worklistSelectedRowData.marketDetails;
        this.formAssess.tfcList = this.worklistSelectedRowData.tfc;
        this.formAssess.firstRequest = this.worklistSelectedRowData.firstRequest;
        this.formAssess.cucChanged = this.worklistSelectedRowData.cucCode;
        this.formAssess.plmkeydate = this.worklistSelectedRowData.keyDate;
        this.formAssess.plmvalidityarea.validityDescription = this.worklistSelectedRowData.plmValidityArea;
        this.formAssess.requestStatus = this.selectedRowData.requestStatus;
        this.formAssess.isMultiComponent = this.worklistSelectedRowData.isMultiComponent;
        this.formAssess.multiComponent = this.worklistSelectedRowData.multiComponent;
        this.formAssess.dosageForMarkets = this.worklistSelectedRowData.dosageForMarkets;
        this.formAssess.raUserId = this.worklistSelectedRowData.raUserID;
        this.formAssess.createdByUserId = this.selectedRowData.submittedByUserId;
        this.formAssess.ifraComplianceModelList = this.worklistSelectedRowData.ifraComplianceModelList;
        this.formAssess.regionalComplianceLevel2ModelList = this.worklistSelectedRowData.regionalComplianceLevel2ModelList;
        this.formAssess.regionalComplianceLevel3ModelList = this.worklistSelectedRowData.regionalComplianceLevel3ModelList;
        if (this.worklistSelectedRowData.marketDetails !== undefined) {
          this.formAssess.projectdetailData.push(this.worklistSelectedRowData.marketDetails);
        }
        this.formAssess.isPlm = this.worklistSelectedRowData.recipeStatus !== '000' ? true : false;
        this.formAssess.nonPlmrecipeId = this.worklistSelectedRowData.cucCode;
        this.formAssess.nonPlmrecipeId_Version = this.worklistSelectedRowData.cucCode + '_' + this.worklistSelectedRowData.cucVer;
        this.worklistservice.setRequestStatus(this.selectedRowData.requestStatus);
      }
      localStorage.setItem('FormObj', JSON.stringify(this.formAssess));
      const val: any = {
        requestID: this.formAssess.requestDisplayID,
        requestStatus: this.formAssess.requestStatus
      };
      this.worklistservice.setRecipeData(val);
      if (!this.formAssess.isPlm) {
        this.dataTrans.setSelectedStep(3);
        this.router.navigate(['/assess-requests/submit-request-nonplm']);
      } else {
        this.dataTrans.setSelectedStep(2);
        this.router.navigate(['/assess-requests/submit-request']);
      }


      this.loading = false;

    }, (error) => {
      this.loading = false;
    });
  }
  /* istanbul ignore next */
  showColumnsDialog() {
    this.initiateColumnOptions();
    this.columnsDialog = true;
    this.position = 'right';
  }

  cancel() {
    this.columnsDialog = false;
  }
  /* istanbul ignore next */
  saveColumnChange(action) {
    this.columnsDialog = false;
    this.loading = true;
    const columnsAddedData = [];
    let activePayload;
    if (action === 'save') {
      activePayload = 1;
    } else if (action === 'reset') {
      activePayload = 0;
    }
    this.columnsAdded.forEach((column, i) => {
      const data = {
        pageName: 'newworklist',
        fieldName: column.fieldName,
        fieldDescription: column.fieldDescription,
        sortOrder: i + 1,
        status: column.status,
        active: activePayload,
        width: column.width
      };
      columnsAddedData.push(data);
    });
    const apiurl = environment.APIFAsT + '/SaveColumnCustomization';
    this.worklistservice.postData(apiurl, columnsAddedData).subscribe((response) => {
      this.getColumnCustomization();
    });
  }
  /* istanbul ignore next */
  drop(event: CdkDragDrop<string[]>) {
    if (event.currentIndex !== 1 && event.currentIndex !== 0) {
      moveItemInArray(this.columnsAdded, event.previousIndex, event.currentIndex);
    }
  }
  /* istanbul ignore next */
  addColumn(): void {
    (this.userForm.get('column') as FormArray).push(
      this.fb.control(null)
    );
    this.columnToBeAddedDetails.forEach(colDetail => {
      this.columnsAdded.push(colDetail);
      this.columnListToAdd = this.columnListToAdd.filter(x => x.fieldName !== colDetail.fieldName);
    });
    if (this.columnListToAdd.length < 1) {
      this.addColumnButton = true;
    }
    this.columnToBeAddedDetails = [];
    this.selectedColumns = [];
  }
  /* istanbul ignore next */
  onColumnChange(value) {
    if (value.fieldName !== 'check') {
      const column = this.orgWorklistColumns.filter(x => x.fieldName === value.fieldName);
      const columnData = column[0];
      columnData.sortOrder = this.columnsAdded.length;
      columnData.status = 1;
      this.columnToBeAddedDetails.push(columnData);
    }
  }

  onDeSelectAllColumn() {
    this.columnToBeAddedDetails = [];
  }

  onSelectAllColumn(value) {
    value.forEach(col => {
      if (value.fieldName !== 'check') {
        const column = this.orgWorklistColumns.filter(x => x.fieldName === col.fieldName);
        const columnData = column[0];
        columnData.sortOrder = this.columnsAdded.length;
        columnData.status = 1;
        this.columnToBeAddedDetails.push(columnData);
      }
    });
  }

  removeColumn(col) {
    this.columnsAdded = this.columnsAdded.filter(x => x.fieldName !== col.fieldName);
    const removedCol = this.allWorklistColumns.filter(x => x.fieldName === col.fieldName);
    this.columnListToAdd.push(removedCol[0]);
    this.columnsAdded.forEach(colRmove => {
      this.columnListToAdd = this.columnListToAdd.filter(x => x.fieldName !== colRmove.fieldName);
    });
    if (this.columnListToAdd.length > 0) {
      this.addColumnButton = false;
    }
  }

  /* istanbul ignore next */
  getColumnDetails(): AbstractControl[] {
    return (<FormArray> this.userForm.get('column')).controls;
  }
  /* istanbul ignore next */
  getUserRoleDetails() {
    this.userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    if (this.userDetails.roles !== undefined && this.userDetails.roles !== null && this.userDetails.roles.length > 0) {
      this.userDetails.roles.forEach(c => {
        if (c.roleId === 150) {
          this.isSuperAdmin = true;
        }
        if (c.roleId === 140 || c.roleId === 130 || c.roleId === 160 || c.roleId === 170) {
          this.isRA = true;
          if (c.roleId === 160) {
            this.isRAviewer = true;
          }
        }
        if (c.roleId === 120 || c.roleId === 110 || c.roleId === 170) {
          this.isRnD = true;
        }
        if (c.roleId === 170) {
          this.isRAandRnD = true;
        }
      });
    }
  }

  /* istanbul ignore next */
  splitLinks(comment, filed) {
    const regex = /<a[^>]*href=["']([^"']*)["']/gm;
    const aregText = /<a(.*?)<\/a>/gm;
    this.CommentsHyperLinks = [];
    let m;
    let getAncharText;
    const totalAnchor = [1, 2, 3, 4, 5, 6, 7];
    const textbetweenTags = [];
    for (const val of totalAnchor) {
      getAncharText = aregText.exec(comment);
      if (getAncharText == null) {
        break;
      }
      if (getAncharText.index === aregText.lastIndex) {
        aregText.lastIndex++;
      }

      getAncharText.forEach((amatch, agroupIndex) => {
        if (agroupIndex === 1) {
          const aindex = amatch.indexOf('>');
          const matchLength = amatch.length;
          textbetweenTags.push(amatch.substring(aindex + 1, matchLength));
        }
      });
    }
    let index = 0;

    for (const val of totalAnchor) {
      m = regex.exec(comment);
      if (m == null) {
        break;
      }
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        if (groupIndex === 1) {
          this.CommentsHyperLinks.push(
            {
              text: this.handleSpecialCharactersForHyperlinks(textbetweenTags[index]),
              hyperlink: match,
              tooltip: match
            });
          index = index + 1;
        }
      });
    }
  }

  splitLinksReport(comment, filed) {
    const regex = /<a[^>]*href=["']([^"']*)["']/gm;
    const aregText = /<a(.*?)<\/a>/gm;
    this.ReportCommentsHyperLinks = [];
    let m;
    let getAncharText;
    const totalAnchor = [1, 2, 3, 4, 5, 6, 7];
    const textbetweenTags = [];
    for (const val of totalAnchor) {
      getAncharText = aregText.exec(comment);
      if (getAncharText == null) {
        break;
      }
      if (getAncharText.index === aregText.lastIndex) {
        aregText.lastIndex++;
      }

      getAncharText.forEach((amatch, agroupIndex) => {
        if (agroupIndex === 1) {
          const aindex = amatch.indexOf('>');
          const matchLength = amatch.length;
          textbetweenTags.push(amatch.substring(aindex + 1, matchLength));
        }
      });
    }
    let index = 0;

    for (const val of totalAnchor) {
      m = regex.exec(comment);
      if (m == null) {
        break;
      }
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        if (groupIndex === 1) {
          this.ReportCommentsHyperLinks.push(
            {
              text: this.handleSpecialCharactersForHyperlinks(textbetweenTags[index]),
              hyperlink: match,
              tooltip: match
            });
          index = index + 1;
        }
      });
    }
  }
  /* istanbul ignore next */
  addExtraColumns() {
    this.isColumnsHasHyperLinks = this.masterWorklistTableExcelColumns.filter(x => x.fieldName === 'rdComment').length > 0 ? 'Yes' : 'No';
    if (this.isColumnsHasHyperLinks === 'Yes') {
      WORKLIST_EXCEL_ADDITIONAL_COLUMNS.forEach(col => {
        this.masterWorklistTableExcelColumns.push(
          {
            fieldName: col.fieldName,
            fieldDescription: col.fieldDescription
          }
        );
      });
    }
  }
  /* istanbul ignore next */
  addExtraColumnsReport() {
    this.isColumnsHasHyperLinks = this.masterWorklistTableExcelColumns.filter(x => x.fieldName === 'reportComments').length > 0 ? 'Yes' : 'No';
    if (this.isColumnsHasHyperLinks === 'Yes') {
      WORKLIST_EXCEL_ADDITIONAL_COLUMNS_REPORT.forEach(col => {
        this.masterWorklistTableExcelColumns.push(
          {
            fieldName: col.fieldName,
            fieldDescription: col.fieldDescription
          }
        );
      });
    }
  }
  clickComment(event) {
    const data = event;
  }

  closePopup() {
    this.isClickHere = false;
  }
  cloasePopupComment() {
    this.isClickHereComments = false;
  }

  /* istanbul ignore next */
  openComment(data) {
    this.isClickHere = true;
    const mydata = data.comments;
    this.tableComment = mydata.replace('<a', '<a target="_blank"');
  }
  /* istanbul ignore next */
  openReportComment(data) {
    this.isClickHereComments = true;
    const mydata = data.rpcomments;
    this.tableComment = mydata.replace('<a', '<a target="_blank"');
  }
  /* istanbul ignore next */
  changeComment(input) {
    const strValue = input.comments;
    const ar = strValue.match(/<a.*?<\/a>/g);
    if ((ar !== null) && (ar.length === 0 || ar.length > 0)) {
      this.commentRD = 'Click Here';
    } else {
      this.commentRD = input.comments;
    }
    return this.commentRD;
  }
  /* istanbul ignore next */
  changeReportComment(input) {
    const strValue = input;
    let commentRD;
    const ar = strValue.match(/<a.*?<\/a>/g);
    if ((ar !== null) && (ar.length === 0 || ar.length > 0)) {
      commentRD = 'Click Here';
    } else {
      commentRD = input;
    }
    return commentRD;
  }
  handleSpecialCharacters(text) {
    if (text !== null && text !== '') {
      return text.replace(/<.*?>/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, ' ').replace(/&amp;/g, '&');
    } else {
      return '';
    }
  }
  handleSpecialCharactersForHyperlinks(text) {
    if (text !== null && text !== '') {
      return text.split(/(<strong>|<\/strong>|<i>|<\/i>|&nbsp;|&amp;)/gi).map((segment) => {
        switch (segment.toLowerCase()) {
          case '&nbsp;':
            return ' ';
          case '&amp;':
            return '&';
          case '<strong>':
          case '</strong>':
          case '<i>':
          case '</i>':
            return '';
          default:
            return segment;
        }
      }).join('');
    } else {
      return '';
    }
  }
  /* istanbul ignore next */
  getActionStatusBasedonRole(marketId, divisionId, actionType, reqCategoryID) {
    this.userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    let selfAssignRequest = true;
    let delegateRequest = true;
    let forwardtoRaRequest = true;
    let rejectRequest = true;
    let actionStatus = true;
    if (this.userDetails !== undefined && this.userDetails !== null && this.userDetails.roles !== undefined && this.userDetails.roles !== null) {
      const fastRoleCount = this.userDetails.roles.filter(f => f.roleId >= 110).length;
      const isSuperAdminUser = this.userDetails.roles.filter(f => f.roleId === 150).length > 0;
      const isRARDUser = this.userDetails.roles.filter(f => f.roleId === 170);
      const isRAUser = this.userDetails.roles.filter(f => f.roleId === 130 || f.roleId === 140);
      const isRAViewer = this.userDetails.roles.filter(f => f.roleId === 160).length > 0;
      if (fastRoleCount > 1 && !isSuperAdminUser && isRARDUser.length > 0) {
        if (isRARDUser[0].market !== null || isRARDUser[0].tfc !== null) {
          const isRARDRowMatched = (isRARDUser.length > 0 && isRARDUser.filter(m => ((m.market !== null && m.market.marketId === marketId) || m.market === null) && ((m.tfc !== null && (m.tfc.tfcId === divisionId || m.tfc.tfcId === reqCategoryID)) || m.tfc === null)).length > 0);
          const isRARowMatched = (isRAUser.length > 0 && isRAUser.filter(m => ((m.market !== null && m.market.marketId === marketId) || m.market === null) && ((m.tfc !== null && (m.tfc.tfcId === divisionId || m.tfc.tfcId === reqCategoryID)) || m.tfc === null)).length > 0);
          if (isRARDRowMatched || isRARowMatched) {
            selfAssignRequest = true;
            delegateRequest = true;
            forwardtoRaRequest = true;
            rejectRequest = true;
          } else {
            selfAssignRequest = false;
            delegateRequest = false;
            forwardtoRaRequest = false;
            rejectRequest = false;
          }
        }
      }
    }
    switch (actionType) {
      case 'selfAssignRequest':
        actionStatus = selfAssignRequest;
        break;
      case 'delegateRequest':
        actionStatus = delegateRequest;
        break;
      case 'forwardtoRaRequest':
        actionStatus = forwardtoRaRequest;
        break;
      case 'rejectRequest':
        actionStatus = rejectRequest;
        break;
    }
    return actionStatus;
  }

  showInstantaneousReport(rowData, isRA) {
    if (isRA) {
      this.updateRAOnSelfAssessementClick();
    }
    this.clearLocalStorage();
    this.loadingWorklistMessage = 'FAsT is checking if additional inputs are required';
    const apiurl = environment.APIFAsTRule + '/rules/engine/checkaadditionalinputrequired/request/' + this.selectedRowData.requestDisplayID;
    this.longTextLoading = true;
    this.worklistservice.getData(apiurl).subscribe((response1) => {
      this.longTextLoading = false;
      let ValidationMessage = '';
      if (response1.isAdditionalInputRequired === 1) {
        this.openAddnlInputPopup = true;
        // ValidationMessage = 'Additional Inputs are not provided despite being required.'
        // this.sendResponseEmail('ADDITIONALINPUTNOTIFICATION', this.selectedRowData.requestDisplayID, '', '', '', '', '', '', false, ValidationMessage);
      } else if (response1.isAdditionalInputRequired === 0) {
        this.viewFinalReport();
      } else if (response1.isAdditionalInputRequired === 2) {
        ValidationMessage = 'TFC-Market mapping has not been maintained.';
        this.sendResponseEmail('SELFASSESSMENTNOTIFICATION', this.selectedRowData.requestDisplayID, '', '', this.selectedRowData.submittedByUserId.toLowerCase(), '', '', '', false, ValidationMessage);
        this.matSnackBar.open(response1.message, 'close', {
          duration: 6000,
          panelClass: ['error']
        });
      } else if (response1.isAdditionalInputRequired === 3) {
        ValidationMessage = 'Rules are not present/active for the below mentioned PUREs. |#|' + response1.pureCodesNotInRule;
        this.sendResponseEmail('SELFASSESSMENTNOTIFICATION', this.selectedRowData.requestDisplayID, '', '', this.selectedRowData.submittedByUserId.toLowerCase(), '', '', '', false, ValidationMessage);
        this.matSnackBar.open(response1.message, 'close', {
          duration: 6000,
          panelClass: ['error']
        });
      }
      this.selectedRow = rowData;
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }
  viewFinalReport() {
    this.loadingWorklistMessage = 'Generating FAsT Report';
    const apiurl = environment.APIFAsTRule + '/rules/engine/requiredinputforinstantaneousreport/request/' + this.selectedRowData.requestDisplayID;
    this.longTextLoading = true;
    this.worklistservice.getData(apiurl).subscribe((response1) => {
      // Calling 2nd API required for report generation
      const apiurl2 = environment.APIFAsTRule + '/rules/engine/instantaneousreport';
      this.worklistservice.postData(apiurl2, response1).subscribe((response2) => {
        this.openAddnlInputPopup = false;
        this.dataTrans.setAssessmentClicked('Self Assessment');
        setTimeout(() => {
          this.completeRequest(null);
        }, 1000);
      }, (error) => {
        this.openAddnlInputPopup = false;
        this.longTextLoading = false;
      });

    }, (error) => {
      this.openAddnlInputPopup = false;
      this.longTextLoading = false;
    });
  }
  clearLocalStorage() {
    this.dataTrans.isViewReportClicked = 'false';
    this.dataTrans.requestStatusForReport = '';
    this.dataTrans.completedReport = '';
  }
  setRequestIDAndStatus() {
    const reqID = this.selectedRowData.requestDisplayID;
    let reqStatus = this.selectedRowData.requestStatus;
    if (this.isRA || this.isSuperAdmin) {
      reqStatus = 'In Progress – RA';
    } else if (this.isRnD) {
      reqStatus = 'In Progress – R&D';
    }
    // Update Request Status :
    const statusUpdateApiUrl = environment.APIFAsT + '/assessment/request/' + reqID + '/status/' + reqStatus + '/comment/SystemGenerated';
    this.loading = true;
    this.loadingWorklistMessage = 'Loading';
    this.assessraService.putData(statusUpdateApiUrl, null).subscribe((statusresponse) => {
      if (statusresponse.message !== null) {
        this.loading = false;
        const val: any = {
          requestID: reqID,
          requestStatus: reqStatus,
        };
        this.worklistservice.setRecipeData(val);
        this.dataTrans.setAssessmentClicked('Self Assessment');
        // Update Recipe Model, by calling another API in the below function
        this.TakeUserInput(this.selectedRow);
      }
    }, (error) => {
      this.loading = false;
    });
  }

  goToAdditionalInputPage() {
    this.clearLocalStorage();
    this.setRequestIDAndStatus();
  }
  closeAddnlInputPopup(masterWorklist) {
    this.openAddnlInputPopup = false;
    this.getWorklistColumns();
    this.getWorkList();
    this.onClearFilters(masterWorklist);
  }

  TakeUserInput(request: any) {
    this.sendRequestId(request);
    let formulationData = [];
    const pureCodeList = [];
    // if (request.requestStatus === 'In Progress – R&D') {
    this.loading = true;
    this.loadingWorklistMessage = 'Loading';
    recipeModel.requestStatus = request.requestStatus;
    const apiurl = environment.APIFAsT + '/executionrequest/' + request.requestDisplayID;
    this.assessraService.getData(apiurl).subscribe((response) => {
      this.loading = false;
      if (response !== null) {
        Object.assign(recipeModel, response);
        recipeModel.marketDetails = response.marketDetails;
        recipeModel.tfcFullText = response.tfc.tfcFullText;
        if (response.tfc.tfcLevel === 5) {
          recipeModel.formulationSubClass = response.tfc.tfcName;
          const tfc5parent = response.tfc.parentTFC;
          if (tfc5parent.tfcLevel === 4) {
            recipeModel.formulationClass = tfc5parent.tfcName;
            const tfc4parent = tfc5parent.parentTFC;
            if (tfc4parent.tfcLevel === 3) {
              recipeModel.formulationType = tfc4parent.tfcName;
              const tfc3parent = tfc4parent.parentTFC;
              if (tfc3parent.tfcLevel === 2) {
                recipeModel.formulationCategory = tfc3parent.tfcName;
                const tfc2parent = tfc3parent.parentTFC;
                if (tfc2parent.tfcLevel === 1) {
                  recipeModel.division = tfc2parent.tfcName;
                }
              }
            }
          }
        }
        formulationData = response.formulationRequestDetails;
        if (formulationData) {
          for (let i = 0; i < formulationData.length; i++) {
            pureCodeList[i] = formulationData[i].pureCode;
          }
          recipeModel.pureCodeList = pureCodeList;
        }
        this.dataTrans.setAssessmentClicked('Self Assessment');
        this.dataTrans.setComponentName('AssessRequestsRA');
        this.dataTrans.setSelectedStep(2);
        this.worklistservice.setProfileObs(request.requestDisplayID);
        this.router.navigate(['assess-request-ra/execute-rules']);
      }
    }, (error) => {
      this.loading = false;
    });
  }

  updateRAOnSelfAssessementClick() {
    // Implementing same functionality as it is in self assign function with slight modifications
    const requestId = this.selectedRowData.requestDisplayID;
    const requestCreatedById = this.selectedRowData.submittedByUserId;
    const cucDescription = this.selectedRowData.cucDescription;
    const selfAssignApiBody = {
      RequestId: requestId,
      UserId: 0,
      AssignmentType: 'Self-Assign'
    };
    // this.loading = true;
    const apiurl = environment.APIFAsT + '/assignnassessmentrequest/self';
    this.worklistservice.selfAssignApi(apiurl, selfAssignApiBody).subscribe((response) => {
      if (response.result === 'Success' && (this.selectedRowData.requestStatus === 'Submitted' || this.selectedRowData.requestStatus === 'Re-Submitted')) {
        this.sendResponseEmail('Assign', requestId, requestCreatedById, '', '', cucDescription, cucDescription, this.selectedRowData.recipeID, this.selectedRowData.isPlm, '');
      }
    }, (error) => {
      this.loading = false;
    });
    if (this.selectedRowData.requestStatus === 'Completed - R&D') {
      // Clear Composition Status and product status of this request after self assign, if the Requeststatus is Completed - R&D
      this.clearCompostionAndProductStatus();
    }
  }

  clearCompostionAndProductStatus() {
    const apiBody = {
      RequestStatusDisplayID: this.selectedRowData.requestDisplayID,
      RequestMarketID: this.selectedRowData.requestMarketID,
      MarketID: this.selectedRowData.marketId
    };
    const apiurl = environment.APIFAsT + '/UpdateCompositionAndProductStatusNull';
    this.worklistservice.postData(apiurl, apiBody).subscribe((response) => {
      if (response.message === 'Success') {
        console.log('Success');
      }
    }, (error) => {
      console.log('Error while updating composition status and product status.');
    });
  }

}

